var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFilterBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 22,
    viewBox: "0 0 24 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.34534 0C0.602331 0 0 0.602332 0 1.34535C0.00225649 1.50377 0.067018 1.65488 0.18018 1.76577L8.92492 10.6066C9.03809 10.7175 9.10285 10.8686 9.10511 11.027V19.3033C9.10488 19.4159 9.13629 19.5262 9.19576 19.6218C9.25523 19.7174 9.34036 19.7943 9.44144 19.8438L14.1862 21.5375C14.2778 21.5824 14.3794 21.6033 14.4814 21.598C14.5833 21.5928 14.6822 21.5616 14.7688 21.5075C14.8553 21.4534 14.9267 21.3781 14.9761 21.2888C15.0254 21.1995 15.0513 21.0991 15.0511 20.997V10.9189C15.0677 10.7566 15.1449 10.6064 15.2673 10.4985L23.8198 1.78979C23.933 1.6789 23.9977 1.52779 24 1.36937C24 0.613088 23.3869 0 22.6306 0H1.34534Z",
    fill: "#007BFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterBlue);
export default __webpack_public_path__ + "static/media/filterBlue.1cbfb0ce7efdf1eae21742e577ddde31.svg";
export { ForwardRef as ReactComponent };